import { StatusProvider } from '@/tax/models';

export class Scenario {
    id = -1;
    name = '';
    companyId = -1;
    periodId = -1;
    periodString = '';
    workflowId = -1;
    firmWorkflowId = -1;
    partnerWorkflowId?: number;
    workflowName = '';
    lastSaved?: Date;
    generic = false;
    creator?: string;

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.name = data.name ?? '';
        this.companyId = data.company_id ?? -1;
        this.periodId = data.period_id ?? -1;
        this.workflowId = data.workflow_id ?? -1;
        this.firmWorkflowId = data.firm_workflow_id ?? -1;
        this.partnerWorkflowId = data.partner_workflow_id ?? undefined;
        this.periodString = data.period_string ?? '';
        this.workflowName = data.workflow_name ?? '';
        this.lastSaved = data.last_saved != null ? new Date(data.last_saved) : undefined;
        this.generic = data.generic ?? false;
        this.creator = data.creator ?? undefined;
        return this;
    }

    serialize(): any {
        return {
            id: this.id,
            name: this.name,
            workflow_id: this.workflowId,
            period_id: this.periodId,
            generic: this.generic,
            creator: this.creator,
        };
    }

    static Copy(scenario: Scenario): Scenario {
        let copy = Object.assign(new Scenario(), JSON.parse(JSON.stringify(scenario)));
        copy.lastSaved = scenario.lastSaved ? new Date(scenario.lastSaved.getTime()) : undefined;
        return copy;
    }
}
